import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { SketchPicker } from "react-color";
import { togglePrintPreviewModal } from "BadgeDesignAction";
import { classNames, IMAGE_PATH } from "Constants";
import {
  DEFAULTFONTSIZE,
  FONTSIZEOPTIONS,
  DEFAULTFONTFAMILY,
  FONTFAMILYOPTIONS,
  DEFAULTFONTWEIGHT,
  FONTWEIGHTOPTIONS,
} from "../badge-constants/index";
import LocaleStrings from "Languages";

const primaryTextColor = "#18203a";
class BadgeEditorHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickerVisible: false,
      selectedColor: primaryTextColor,
    };
  }

  /* Print preview  */
  printPreview = (props) => {
    this.props.togglePrintPreviewModal(true); //  It will open print preview modal
  };

  openColorPicker = (field) => {
    this.setState({
      pickerVisible: true,
      selectedColor:
        field.length > 0 && field[0].style.color
          ? `${field[0].style.color}`
          : primaryTextColor,
    });
  };

  closeColorPicker = () => {
    this.setState({
      pickerVisible: false,
    });
  };

  resetColorPicker = () => {
    let { selectedElement, templateJson } = this.props;
    var selected = _.filter(templateJson, (obj) => {
      return obj.name === selectedElement.name;
    });

    // console.log("selected :0- ", selected);

    this.setState({
      pickerVisible: false,
      selectedColor:
        selected.length > 0 && selected[0].style.color
          ? `${selected[0].style.color}`
          : primaryTextColor,
    });
  };

  handleColorChange = ({ hex }) => {
    this.props.optionSelect("", hex, "color");
    this.setState({ selectedColor: hex });
  };

  render() {
    let { selectedElement, templateJson } = this.props;
    let { pickerVisible, selectedColor } = this.state;

    var selected = _.filter(templateJson, (obj) => {
      return obj.name === selectedElement.name;
    });
    // console.log("selected :- ", selected);

    return (
      <>
        {/* Font Size */}
        <div className="dropdown-btn-container">
          <DropdownButton
            className="dropdown-white-btn badge-dropdown"
            title={
              selected.length > 0 && selected[0].style.fontSize
                ? selected[0].style.fontSize
                : DEFAULTFONTSIZE
            }
            key="1"
            id="dropdown-basic-1"
            nocaret="true"
          >
            {_.map(FONTSIZEOPTIONS, (opt, i) => {
              return (
                <Dropdown.Item
                  key={`${opt.value}_${i}`}
                  eventKey={opt.value}
                  onClick={(e) =>
                    this.props.optionSelect(e, opt.value, "fontSize")
                  }
                >
                  <span style={{ fontSize: 16 }}>{opt.label}</span>
                </Dropdown.Item>
              );
            })}
          </DropdownButton>
        </div>

        {/* Font Weight */}
        {/* <div className="dropdown-btn-container ml-2">
          <DropdownButton
            className="dropdown-white-btn"
            title={
              selected.length > 0 && selected[0].style.fontWeight
                ? selected[0].style.fontWeight
                : DEFAULTFONTWEIGHT
            }
            key="1"
            id="dropdown-basic-1"
            nocaret="true"
          >
            {_.map(FONTWEIGHTOPTIONS, (opt, i) => {
              return (
                <Dropdown.Item
                  key={`${opt.value}_${i}`}
                  eventKey={opt.value}
                  onClick={(e) =>
                    this.props.optionSelect(e, opt.value, "fontWeight")
                  }
                >
                  <span style={{ fontWeight: opt.value }}>{opt.label}</span>
                </Dropdown.Item>
              );
            })}
          </DropdownButton>
        </div> */}

        {/* Font Family */}
        <div className="dropdown-btn-container ml-2">
          <DropdownButton
            className="dropdown-white-btn badge-dropdown"
            title={
              selected.length > 0 && selected[0].style.fontFamily
                ? selected[0].style.fontFamily
                : DEFAULTFONTFAMILY
            }
            key="1"
            id="dropdown-basic-1"
            nocaret="true"
            style={{ minWidth: "220px" }}
          >
            {_.map(FONTFAMILYOPTIONS, (opt, i) => {
              return (
                <Dropdown.Item
                  key={`${opt.value}_${i}`}
                  eventKey={opt.value}
                  onClick={(e) =>
                    this.props.optionSelect(e, opt.value, "fontFamily")
                  }
                >
                  <span style={{ fontFamily: opt.value }}>{opt.label}</span>
                </Dropdown.Item>
              );
            })}
          </DropdownButton>
        </div>

        {/* Font Weight */}
        <div
          className={classNames(
            selected.length > 0 &&
              selected[0].style.fontWeight &&
              selected[0].style.fontWeight === "bold"
              ? "biu-selected"
              : "",
            "biu ml-2"
          )}
          onClick={(e) => this.props.handleCustomEditorButtons(e, "b")}
        >
          <i className="fa fa-bold" aria-hidden="true"></i>
        </div>

        {/* Font Style */}
        <div
          className={classNames(
            selected.length > 0 &&
              selected[0].style.fontStyle &&
              selected[0].style.fontStyle === "italic"
              ? "biu-selected"
              : "",
            "biu ml-2"
          )}
          onClick={(e) => this.props.handleCustomEditorButtons(e, "i")}
        >
          <i className="fa fa-italic" aria-hidden="true"></i>
        </div>

        {/* Text Decoration */}
        {/* <div
          className={classNames(
            selected.length > 0 &&
              selected[0].style.textDecoration &&
              selected[0].style.textDecoration === "underline"
              ? "biu-selected"
              : "",
            "biu ml-2"
          )}
          onClick={(e) => this.props.handleCustomEditorButtons(e, "u")}
        >
          <i className="fa fa-underline" aria-hidden="true"></i>
        </div> */}

        {/* Text Alignment */}
        <div
          className={classNames(
            selected.length > 0 &&
              selected[0].style.textAlign &&
              selected[0].style.textAlign === "center"
              ? "biu-selected"
              : "",
            "biu ml-2"
          )}
          onClick={(e) => this.props.handleCustomEditorButtons(e, "text-align")}
        >
          <i className="fa fa-align-center" aria-hidden="true"></i>
        </div>

        <>
          <div
            className={classNames("biu ml-2")}
            style={{
              color: selectedColor,
            }}
            onClick={() => this.openColorPicker(selected)}
          >
            <i className="fa fa-font" aria-hidden="true"></i>
          </div>

          <div
            style={{ position: "relative", top: 20, left: "-75px" }}
            ref={(node) => {
              this.node = node;
            }}
          >
            {pickerVisible && (
              <div className="picker-container" style={{ zIndex: 2200 }}>
                <img
                  className="picker-close-button"
                  src={`${IMAGE_PATH}v2_icons/circle_cross_solid.png`}
                  onClick={this.closeColorPicker}
                />
                <SketchPicker
                  color={selectedColor}
                  onChangeComplete={this.handleColorChange}
                />
              </div>
            )}
          </div>
        </>

        <div
          className={classNames(
            selected.length > 0 &&
              selected[0].style.textTransform &&
              selected[0].style.textTransform === "uppercase"
              ? "biu-selected"
              : "",
            "biu ml-2"
          )}
          onClick={(e) =>
            this.props.handleCustomEditorButtons(e, "text-transform")
          }
        >
          {LocaleStrings.uppercase}
        </div>

        {/* <button
          type="button"
          className="btn btn-custom-blue btn btn-primary ml-2"
          onClick={() => this.printPreview()}
        >
          {LocaleStrings.dashboard_badgedesign_preview}{" "}
          <i className="fa fa-eye" aria-hidden="true"></i>
        </button> */}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    templateJson: state.templateJson,
    selectedElement: state.selectedElement,
  };
}

export default connect(mapStateToProps, { togglePrintPreviewModal }, null, {
  forwardRef: true,
})(BadgeEditorHeader);
